import { ScrollLock } from './../utils/scroll-lock.js';
import { FocusLock } from './../utils/focus-lock.js';

export const initMessage = function () {
  const breakpoint = 1500;
  const btnMessage = document.querySelectorAll('[data-message-open]');
  const boxMessage = document.querySelectorAll('[data-message]');
  const overlayMessage = document.querySelectorAll('[data-message-overlay]');
  const btnMessageClose = document.querySelectorAll('[data-message-close]');
  // const scrollLock = new ScrollLock();
  const focusLock = new FocusLock('startFocus: true');

  if (btnMessage.length > 0) {
    btnMessage.forEach((item) => {
      item.addEventListener('click', function (i) {
        i.preventDefault();
        const parent = item.closest('[data-message]');
        if (parent) {
          if (parent.classList.contains('is-active')) {
            closeMessage(item);
          } else {
            parent.classList.add('is-active');
            item.classList.add('is-active');

            // if (breakpoint >= window.innerWidth) {
            //   scrollLock.disableScrolling();
            // }
            focusLock.lock('.is-active[data-message] .message__inner');
          }
        }
      })
    })

  }
  const closeMessage = function (item) {
    const parent = item.closest('.is-active[data-message]');
    if (parent) {
      parent.classList.remove('is-active');
      item.classList.remove('is-active');

      // if (breakpoint >= window.innerWidth) {
      //   scrollLock.enableScrolling();
      // }
      focusLock.unlock('is-active[data-message] .message__inner');
    }
  }
  if (btnMessageClose.length > 0) {
    btnMessageClose.forEach((item) => {
      item.addEventListener('click', function (i) {
        i.preventDefault();
        closeMessage(item);
      })
    })
  }

  if (overlayMessage) {
    overlayMessage.forEach((item) => {
      item.addEventListener('click', (i) => {
        const evtTarget = i.target;
        if (evtTarget == item) {
          closeMessage(item);
        }
      })
    })
  }

  window.addEventListener("keydown", function (e) {
    if (e.keyCode == 27) {
      const boxMessageOpen = document.querySelector('.is-active[data-message]');
      if (boxMessageOpen) {
        boxMessageOpen.classList.remove('is-active');
      }
    }
  }, true)
}
